import s from "../../pages/info-page/styles.module.css";

export function TrafficsIcon({styleSVG}) {
    return (
        <svg className={s[`${styleSVG}`]} viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.30273 11L12.3027 14L22.3027 4" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M21.3027 12V19C21.3027 19.5304 21.092 20.0391 20.7169 20.4142C20.3419 20.7893 19.8332 21 19.3027 21H5.30273C4.7723 21 4.26359 20.7893 3.88852 20.4142C3.51345 20.0391 3.30273 19.5304 3.30273 19V5C3.30273 4.46957 3.51345 3.96086 3.88852 3.58579C4.26359 3.21071 4.7723 3 5.30273 3H16.3027" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}